import shellEn from "./shell.en";
import shellFr from "./shell.fr";
import linksEn from "./links.en";
import linksFr from "./links.fr";
import visitorsEn from "./visitors.en";
import visitorsFr from "./visitors.fr";
import membersEn from "./members.en";
import membersFr from "./members.fr";
import contentEn from "./content.en";
import contentFr from "./content.fr";

export const adminEn = { ...shellEn, ...linksEn, ...visitorsEn, ...membersEn, ...contentEn };
export const adminFr = { ...shellFr, ...linksFr, ...visitorsFr, ...membersFr, ...contentFr };
